import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { closeModal } from "../../../../state/reducers/communicationSlice";
import { BsDatabaseFillDown } from "react-icons/bs";
import { FaPaste } from "react-icons/fa";
import UploadExcelFile from "./UploadExcelFile";

const CreateContact = ({ fetchContacts, onClose }) => {
  const dispatch = useDispatch();
  const [selectedOption, setSelectedOption] = useState(null);

  // Handle closing the modal
  const handleCloseModal = () => {
    if (onClose) {
      onClose(); // Trigger the parent-provided `onClose` callback
    } else {
      dispatch(closeModal()); // Default action to close modal
    }
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      handleCloseModal();
    }
  };

  // Render child component (UploadExcelFile) if an option is selected
  if (selectedOption === "excel" || selectedOption === "copy-paste") {
    return (
      <UploadExcelFile
        fetchContacts={fetchContacts}
        handleCloseModal={handleCloseModal}
        onClose={() => setSelectedOption(null)}
        uploadType={selectedOption}
      />
    );
  }

  return (
    <div
      className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-[1000] p-4"
      onClick={handleBackdropClick}
    >
      <div className="bg-white w-full max-w-sm sm:max-w-md lg:max-w-lg xl:max-w-2xl rounded-lg shadow-lg relative max-h-[90vh] overflow-y-auto">
        {/* Modal Header */}
        <div className="flex justify-between items-center p-4 sm:p-6 border-b border-gray-200">
          <h2 className="text-lg sm:text-xl font-semibold text-gray-800">
            Create a Contact
          </h2>
          <button
            className="text-gray-500 hover:text-gray-800 text-xl p-1 hover:bg-gray-100 rounded-full transition-colors"
            onClick={handleCloseModal}
          >
            &times;
          </button>
        </div>

        {/* Options */}
        <div className="p-4 sm:p-6 lg:p-8">
          <div className="flex flex-col sm:flex-row justify-center items-center gap-4 sm:gap-6">
            {/* Excel Option */}
            <div
              className="flex flex-col items-center justify-center w-full sm:w-64 lg:w-80 h-48 sm:h-56 lg:h-60 bg-blue-50 rounded-lg shadow hover:shadow-lg hover:scale-105 transition-all cursor-pointer p-6"
              onClick={() => setSelectedOption("excel")}
            >
              <BsDatabaseFillDown className="text-purple-600 text-4xl sm:text-5xl mb-3 sm:mb-4" />
              <p className="text-gray-800 font-medium text-sm sm:text-base text-center">
                Import contacts from Excel
              </p>
            </div>

            {/* Manual Option - Commented out in original */}
            {/* <div
              className="flex flex-col items-center justify-center w-full sm:w-64 lg:w-80 h-48 sm:h-56 lg:h-60 bg-blue-50 rounded-lg shadow hover:shadow-lg hover:scale-105 transition-all cursor-pointer p-6"
              onClick={() => setSelectedOption("copy-paste")}
            >
              <FaPaste className="text-blue-500 text-4xl sm:text-5xl mb-3 sm:mb-4" />
              <p className="text-gray-800 font-medium text-sm sm:text-base text-center">
                Manual or Copy-Paste
              </p>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateContact;
